import { render } from "./MenuListSwiperItem.vue?vue&type=template&id=d61fc78a"
import script from "./MenuListSwiperItem.vue?vue&type=script&lang=js"
export * from "./MenuListSwiperItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__